import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Purchase from "@/pages/Purchase";
import ThankYou from "@/pages/ThankYou";
import Admin from "@/pages/Admin";
import Poster from "@/pages/Poster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Purchase />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/poster" element={<Poster />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#333333",
            color: "#F5F5F5",
            border: "1px solid #C77B7B",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
